import { z } from 'zod';
export const SupplierSummary = z.object({
    id: z.string(),
    name: z.string(),
    shortName: z.string().nullable(),
    legalAddress: z.string(),
    inn: z.string(),
    kpp: z.string().nullable(),
    ogrn: z.string(),
    bankName: z.string(),
    bankAccount: z.string(),
    bankCorr: z.string(),
    bankBik: z.string(),
    directorName: z.string(),
    directorGenitive: z.string(),
    directorShort: z.string(),
    directorTitle: z.string(),
    signatoryBasis: z.string(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    isDefault: z.boolean(),
    archived: z.boolean(),
});
export const CreateSupplierRequest = z.object({
    name: z.string().min(1).max(500),
    shortName: z.string().max(200).nullable().optional(),
    legalAddress: z.string().min(1),
    inn: z.string().min(10).max(12),
    kpp: z.string().max(9).nullable().optional(),
    ogrn: z.string().min(13).max(15),
    bankName: z.string().min(1),
    bankAccount: z.string().min(1),
    bankCorr: z.string().min(1),
    bankBik: z.string().min(1),
    directorName: z.string().min(1),
    directorGenitive: z.string().min(1),
    directorShort: z.string().min(1),
    directorTitle: z.string().min(1).optional(),
    signatoryBasis: z.string().min(1).optional(),
    phone: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    isDefault: z.boolean().optional(),
});
export const PatchSupplierRequest = CreateSupplierRequest.partial().extend({
    archived: z.boolean().optional(),
});
//# sourceMappingURL=suppliers.js.map